import { AsyncWidgetConfigurationNav } from '@jira/navigation-apps__horizontal-nav-csm-widget-configuration/src/AsyncWidgetConfigurationNav.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { widgetAnonymousAccessResource } from '@jira/router-resources__widget-anonymous-access/src/widgetAnonymousAccessResource.tsx';
import { SidebarIdCsmApp } from '@jira/navigation-apps__constants/src/SidebarIdCsmApp.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { installEntryPoint as main } from '@jira/spa-apps__help-center-settings-widget-configuration-install/src/installEntryPoint.entrypoint.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { csmAppSidebarEntryPoint } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-csm-app/src/csmAppSidebarEntryPoint.entrypoint.tsx';
import { horizontalNavigationCsmWidgetConfigurationEntryPoint } from '@jira/navigation-apps__horizontal-nav-csm-widget-configuration/src/horizontalNavigationCsmWidgetConfigurationEntryPoint.entrypoint.tsx';
import { csmExperienceWidgetConfigurationInstallRoute } from '@jira/router-routes__help-center-settings-routes/src/csmExperienceWidgetConfigurationInstallRoute.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { getCustomerServiceL1NavigationResources } from '@jira/router-resources__customer-service-l1-navigation/src/getCustomerServiceL1NavigationResources.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';

import { getCsmExperiencesResources } from './getCsmExperiencesResources.tsx';

const csmExperienceWidgetConfigurationInstallPageEntryPoint = createPageEntryPoint({
	main,
	horizontalNavigation: horizontalNavigationCsmWidgetConfigurationEntryPoint,
	leftSidebar: {
		sidebar: csmAppSidebarEntryPoint,
	},
});

export const csmExperienceWidgetConfigurationInstallRouteEntry: Route = createEntry(
	csmExperienceWidgetConfigurationInstallRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'customer-service.csm-experience-widget-configuration.install',
		layout: serviceProjectLayout,
		navigation: {
			sidebarId: SidebarIdCsmApp,
			horizontal: AsyncWidgetConfigurationNav,
		},
		entryPoint() {
			return fg('csm_appification_standalone_navigation')
				? csmExperienceWidgetConfigurationInstallPageEntryPoint
				: notFoundPageEntrypoint;
		},
		resources: [
			...getCustomerServiceL1NavigationResources(),
			...getCsmExperiencesResources(),
			staticProjectSidebarNavigationResource,
			widgetAnonymousAccessResource,
		],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
